import type { DropdownProps } from './types';

export function normalizeOptions(options: DropdownProps['options']) {
  const normalizedOptions: {
    key: string;
    value: string;
    disabled?: boolean;
  }[] = [];
  if (Array.isArray(options)) {
    for (const option of options) {
      if (typeof option === 'string') {
        normalizedOptions.push({ key: option, value: option });
      } else {
        normalizedOptions.push(option);
      }
    }
  } else {
    for (const key of Object.keys(options)) {
      normalizedOptions.push({ key, value: options[key] });
    }
  }

  return normalizedOptions;
}
